import React from "react";
export default function FooterSection() {
  return (
      <div className="footer_section">
        <div className="col">
          <p>© {new Date().getFullYear()} InsureOnline.com, All rights reserved</p>
        </div>
        <div className="col">
          <div className="menu-footer-holder">
            <a
              href="https://www.facebook.com/InsureOnline.comInc"
              target="_blank"
              className="socialLink"
            >
              <div alt="Facebook" className="facebook"></div>
            </a>
            <a
              href="https://www.instagram.com/insureonline.com_/"
              target="_blank"
              className="socialLink"
            >
              <div alt="Instagram" className="instagram"></div>
            </a>
            <a
              href="https://www.linkedin.com/company/insureonline/"
              target="_blank"
              className="socialLink"
            >
              <div alt="LinkedIn" className="linkedIn"></div>
            </a>
            <a
              href="https://www.youtube.com/channel/UCYeBQ5eRTJJ9B0bHNWpiGtg"
              target="_blank"
              className="socialLink"
            >
              <div alt="youTube" className="youTube"></div>
            </a>
          </div>
        </div>
    </div>
  );
}
